<script>

export default {
  name: 'loading-indicators',
  install(Vue) {
    /** Set global loading indicator */
    Object.defineProperty(Vue.prototype, '$loading', {
      get() {
        return this.$root.loading
      },
      set(value) {
        this.$root.loading = value
      }
    })
  },

  /**
   * Hooks for loading indicators
   *
   */
  hook: {
    start(request) {
      var spots = []

      if (request && request.url) {
        spots = global.jQuery('[endpoint^="' + request.url + '"]')
      }

      if (spots.length) {
        spots.addClass('loading')
      } else {
        ;((this.$loading ? this : null) || global.app).$loading = true
      }
    },
    stop(response) {
      ;((this.$loading ? this : null) || global.app).$loading = false

      if (response) {
        global.jQuery('[endpoint^="' + response.config.url.replace(response.config.baseURL, '') + '"]').removeClass('loading')
      } else {
        global.jQuery('[endpoint]').removeClass('loading')
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?380ee727